import { useState } from 'react';
import {
  FaChevronDown,
  FaRegUser,
  FaFileInvoiceDollar,
  FaSignOutAlt,
  FaCashRegister,
  FaExclamationTriangle,
} from 'react-icons/fa';
import { BsInboxes, BsBank2 } from "react-icons/bs";
import { LuReceiptText } from "react-icons/lu";
import { FiShoppingCart } from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";
import { LuPlus } from "react-icons/lu";
import { GoGear } from "react-icons/go";
import { HiDocumentReport } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import { useContextoSesion } from '../../miscelaneo/ContextoSesion';


// Subcomponente para submenús
function Submenu({ items }) {
  return (
    <div className="pl-6 space-y-1">
      {items.map((item) => (
        <a
          key={item.label}
          href={item.href}
          className="block text-sm rounded-xl border border-transparent hover:border-color-primario px-2 py-1  hover:bg-gray-200"
        >
          {item.label}
        </a>
      ))}
    </div>
  );
}

export const menuItems = [
  {
    label: 'Dashboard',
    icon: RxDashboard,
    href: '/Dashboard',
    // Dashboard siempre visible (sin permiso requerido)
  },
  {
    label: 'Entidades',
    icon: FaRegUser,
    submenu: [
      { label: 'Mantenimiento de Entidades', href: '/MantenimientoEntidad', permiso: 'modulo_entidad' },
    ],
  },
  {
    label: 'Ventas',
    icon: FaFileInvoiceDollar,
    permiso: 'modulo_venta',
    submenu: [
      { label: 'Punto de Venta', href: '/ProcesoPOS', permiso: 'venta_crear_factura' },
      { label: 'Factura Demo', href: '/FacturaDemo', permiso: 'venta_crear_factura' },
      { label: 'Importar Facturas Lite', href: '/ImportarLite', permiso: 'venta_crear_factura' },
      { label: 'Notas de Crédito/Débito', href: '/ProcesoNotasFactura', permiso: 'venta_notas' },
      { label: 'Consultar Facturas', href: '/Facturas', permiso: 'venta_ver_facturas' },
      { label: 'Cotización', href: '/ProcesoCotizacion', permiso: 'cotizacion_crear' },
      { label: 'Consultar Cotizaciones', href: '/Cotizaciones', permiso: 'cotizacion_ver' }
    ],
  },
  {
    label: 'Compras',
    icon: FiShoppingCart,
    permiso: 'modulo_compra',
    submenu: [
      { label: 'Registrar Compra', href: '/CompraUnificada', permiso: 'compra_crear' },
      { label: 'Consultar Compras', href: '/CuentasPorPagar', permiso: 'modulo_compra' },
      { label: 'Gastos Menores', href: '/ProcesoGastoMenor', permiso: 'compra_gastos_menores' },
    ],
  },
  {
    label: 'Caja',
    icon: FaCashRegister,
    permiso: 'modulo_venta',
    submenu: [
      { label: 'Apertura de Caja', href: '/AperturaCaja', permiso: 'caja_abrir' },
      { label: 'Cierre de Caja', href: '/CierreCaja', permiso: 'caja_cerrar' },
      { label: 'Resumen de Movimientos', href: '/ResumenMovimientos', permiso: 'caja_ver_resumen' },
      { label: 'Monitoreo de Cajas', href: '/DashboardMonitoreoCajas', permiso: 'caja_dashboard_monitoreo' },
      { label: 'Retiro de Caja', href: '/ResumenMovimientos?retiro=1', permiso: 'caja_retiro' },
      { label: 'Historial de Cierres', href: '/HistorialCierres', permiso: 'caja_ver_historial' },
      { label: 'Cobros', href: '/PerfilCliente' }
    ],
  },
  {
    label: 'Inventario',
    icon: BsInboxes,
    permiso: 'modulo_inventario',
    submenu: [
      { label: 'Productos', href: '/MantenimientoProducto', permiso: 'modulo_inventario' },
      { label: 'Transferencias', href: '/ProcesoTransferencia', permiso: 'inventario_transferencia' },
      { label: 'Ajustes', href: '/ProcesoAjuste', permiso: 'inventario_ajuste' },
    ],
  },
  {
    label: 'Reportes',
    icon: HiDocumentReport,
    submenu: [
      { label: 'Movimientos del día', href: '/ReportesMovimientosDia', permiso: 'reportes_movimientos_dia' },
      { label: 'Reporte de ventas', href: '/ReportesVentas', permiso: 'reportes_ventas' },
      { label: 'Estado de cuenta de cliente', href: '/ReportesEstadoCuenta', permiso: 'modulo_reportes' },
    ],
  },
  {
    label: 'Tesorería',
    icon: BsBank2,
    submenu: [
      { label: 'Cuentas Bancarias y Cajas', href: '/MantenimientoCuentaTesoreria', permiso: 'banco_ver_cuentas' }
    ],
  },
  {
    label: 'Catálogos',
    icon: LuPlus,
    submenu: [
      { label: 'Categorías de Producto', href: '/MantenimientoCategoria', permiso: 'categoria_ver' },
      { label: 'Tipos de Costos y Gastos', href: '/ProcesoCostosGastos', permiso: 'costos_gastos_ver' },
      { label: 'Sucursales', href: '/MantenimientoAlmacen', permiso: 'inventario_ver_almacenes' }
    ],
  },
  {
    label: 'Comprobante Fiscal',
    icon: LuReceiptText,
    permiso: 'dashboard_ecf_ver',
    submenu: [
      { label: 'Resumen eCF', href: '/DashboardECF', permiso: 'dashboard_ecf_ver' },
      { label: 'Secuencias de Comprobantes', href: '/MantenimientoSecuenciasComprobante', permiso: 'config_secuencias' }
    ],
  },
  {
    label: 'Configuración',
    icon: GoGear,
    permiso: 'modulo_configuracion',
    submenu: [
      { label: 'Valores por Defecto', href: '/ValoresPorDefecto', permiso: 'config_valores_defecto' },
      { label: 'Pasarelas de Pago', href: '/ConfiguracionPasarelas', permiso: 'config_pasarelas' },
      { label: 'Usuarios y Permisos', href: '/AdministracionPermisos', permiso: 'modulo_permisos' },
      { label: 'Configuración de Impresión', href: '/ConfiguracionImpresion', permiso: 'banco_ver_cuentas' },
      { label: 'Configuración POS', href: '/ConfiguracionPOS', permiso: 'banco_ver_cuentas' }
    ],
  },
];

export default function Sidebar({ abierto = false, onCerrar = () => {} }) {
  const [openMenu, setOpenMenu] = useState(null);
  const [mostrarModalLogout, setMostrarModalLogout] = useState(false);
  const { cerrarSesion, sesionCaja, tienePermiso } = useContextoSesion();
  const navigate = useNavigate();

  const toggleMenu = (label) => {
    setOpenMenu(openMenu === label ? null : label);
  };

  const confirmarLogout = () => {
    cerrarSesion();
  };

  // Filtrar items del menu segun permisos
  const menuFiltrado = menuItems
    .filter(item => {
      // Si no tiene permiso requerido, siempre visible
      if (!item.permiso) return true;
      return tienePermiso(item.permiso);
    })
    .map(item => {
      if (!item.submenu) return item;
      // Filtrar submenu items por permiso
      const submenuFiltrado = item.submenu.filter(sub => {
        if (!sub.permiso) return true;
        return tienePermiso(sub.permiso);
      });
      // Si el submenu queda vacio, ocultar el menu padre
      if (submenuFiltrado.length === 0) return null;
      return { ...item, submenu: submenuFiltrado };
    })
    .filter(Boolean);

  return (
    <>
    {/* Fondo oscuro del drawer (solo móvil) */}
    {abierto && (
      <div className="fixed inset-0 z-[55] bg-black bg-opacity-50 md:hidden" onClick={onCerrar} />
    )}
    <aside
      className={`w-64 bg-gray-100 text-gray-800 p-3 flex flex-col overflow-y-auto scrollbar-hide border border-gray-300 shadow-md
        fixed inset-y-0 left-0 z-[60] transition-transform duration-200 ${abierto ? 'translate-x-0' : '-translate-x-full'}
        md:static md:translate-x-0 md:z-auto md:rounded-xl md:mx-1 md:mt-2`}
      style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 1rem)' : '100vh' }}
      onClick={(e) => { if (e.target.closest('a')) onCerrar(); }}
    >
      <div className="space-y-2">
        {menuFiltrado.map((item) => {
          const Icon = item.icon;

          if (!item.submenu) {
            return (
              <a
                key={item.label}
                href={item.href}
                className="flex items-center gap-2 px-2 py-1 rounded-xl border border-transparent hover:border-color-primario hover:bg-gray-200"
              >
                <Icon className="text-color-primario text-xl" /> {item.label}
              </a>
            );
          }

          return (
            <div key={item.label}>
              <button
                onClick={() => toggleMenu(item.label)}
                className="flex items-center justify-between w-full px-2 py-1 rounded-xl border border-transparent hover:border-color-primario hover:bg-gray-200"
              >
                <span className="flex items-center gap-2">
                  <Icon className="text-color-primario text-xl"  /> {item.label}
                </span>
                <FaChevronDown
                  className={`transform transition-transform ${
                    openMenu === item.label ? 'rotate-180' : ''
                  } text-color-primario`}
                />
              </button>
              {openMenu === item.label && <Submenu items={item.submenu} />}
            </div>
          );
        })}

        {/* Logout */}
        <button
          onClick={() => setMostrarModalLogout(true)}
          className="flex items-center gap-2 px-2 py-1 rounded-xl border border-transparent hover:border-color-primario hover:bg-gray-200 w-full"
        >
          <FaSignOutAlt className="text-color-primario text-xl" /> Cerrar Sesión
        </button>
      </div>

    </aside>

      {/* Modal de Confirmación de Logout */}
      {mostrarModalLogout && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-2xl transform transition-all duration-300">
            {/* Icono */}
            <div className="flex justify-center mb-4">
              <div className="bg-red-100 rounded-full p-4">
                <FaSignOutAlt className="text-red-600" size={32} />
              </div>
            </div>

            {/* Título */}
            <h3 className="text-xl font-bold text-gray-800 text-center mb-2">
              ¿Cerrar Sesión?
            </h3>

            {/* Advertencia de caja abierta */}
            {sesionCaja && (
              <div className="bg-yellow-50 border border-yellow-300 rounded-xl p-3 mb-4 flex items-start gap-2">
                <FaExclamationTriangle className="text-yellow-500 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p className="font-semibold text-yellow-700">¡Tienes una caja abierta!</p>
                  <p className="text-yellow-600">Caja: {sesionCaja.nombre_caja}</p>
                </div>
              </div>
            )}

            {/* Mensaje */}
            <p className="text-gray-600 text-center mb-6">
              {sesionCaja 
                ? '¿Qué deseas hacer?' 
                : '¿Está seguro de que desea cerrar sesión?'}
            </p>

            {/* Botones */}
            <div className="flex flex-col gap-3">
              {sesionCaja && (
                <button
                  onClick={() => {
                    setMostrarModalLogout(false);
                    navigate('/CierreCaja');
                  }}
                  className="w-full px-4 py-3 bg-orange-500 text-white rounded-xl font-medium hover:bg-orange-600 transition-all duration-200 shadow-md"
                >
                  Cerrar Caja y Salir
                </button>
              )}
              <div className="flex gap-3">
                <button
                  onClick={() => setMostrarModalLogout(false)}
                  className="flex-1 px-4 py-3 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-all duration-200"
                >
                  Cancelar
                </button>
                <button
                  onClick={confirmarLogout}
                  className="flex-1 px-4 py-3 bg-red-600 text-white rounded-xl font-medium hover:bg-red-700 transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  {sesionCaja ? 'Salir sin cerrar caja' : 'Cerrar Sesión'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}